/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useEffect } from "react";

import { useDrawerStore } from "@/stores/useDrawerStore";
import { useMainBannerStore } from "@/stores/useMainBannerStore";

import { colors } from "@dotnet/telematics-design-system";

import { useMediaQueries } from "../../../shared";
import useGeneralHeights from "../../../shared/hooks/useGeneralHeights";
import Navigation from "../Navigation/Navigation";
import { useStyles } from "../styles";
import ToggleDrawerButton from "./components/ToggleDrawerButton/ToggleDrawerButton";

const DesktopDrawer = () => {
  const { to1099 } = useMediaQueries();

  const mainBannerHeight = useMainBannerStore(state => state.height);

  const {
    CLOSE_DESKTOP_DRAWER_WIDTH_WITHOUT_PADDING,
    OPEN_DESKTOP_DRAWER_WIDTH_WITHOUT_PADDING
  } = useGeneralHeights(mainBannerHeight);

  const { desktopdrawerAside, desktopdrawerContent } = useStyles();

  const { isDesktopDrawerOpen, setIsDesktopDrawerOpen } = useDrawerStore();

  useEffect(() => {
    to1099 && handleCloseDrawer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [to1099]);

  const handleOpenDrawer = () => {
    setIsDesktopDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDesktopDrawerOpen(false);
  };

  return (
    <aside
      id="desktopDrawer"
      data-testid="DesktopDrawer"
      css={css([
        {
          background: colors.gray50,
          borderRight: `1px solid ${colors.gray200}`,
          width: isDesktopDrawerOpen
            ? OPEN_DESKTOP_DRAWER_WIDTH_WITHOUT_PADDING
            : CLOSE_DESKTOP_DRAWER_WIDTH_WITHOUT_PADDING
        },
        desktopdrawerAside
      ])}
    >
      <div css={css(desktopdrawerContent)}>
        <Navigation />
        {!to1099 && (
          <ToggleDrawerButton
            isdrawerOpen={isDesktopDrawerOpen}
            onOpendrawer={handleOpenDrawer}
            onDrawerClose={handleCloseDrawer}
          />
        )}
      </div>
    </aside>
  );
};

export default DesktopDrawer;
